import React from 'react';

import SvgContainer from '../SvgContainer';

const PointerUp = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100949)">
                <path d="M12.553 5.09934C12.8076 5.38454 12.8076 5.81546 12.553 6.10066C12.2543 6.43517 11.7311 6.43545 11.4321 6.10127L8.71429 3.064L8.71429 15.2857C8.71429 15.6802 8.39449 16 8 16C7.60551 16 7.28571 15.6802 7.28571 15.2857L7.28571 3.064L4.57152 6.1039C4.27105 6.44042 3.74427 6.4395 3.44499 6.10192C3.19127 5.81574 3.19203 5.38493 3.44675 5.09964L7.25406 0.835451C7.65166 0.390139 8.34834 0.390138 8.74594 0.83545L12.553 5.09934Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100949">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default PointerUp;
